import * as types from "./types";

export const getProfileEditRequestsRequest = (payload) => ({
  type: types.GET_PROFILE_EDIT_REQUESTS_REQUEST,
  payload,
});

export const getProfileEditRequestsResponse = (payload) => ({
  type: types.GET_PROFILE_EDIT_REQUESTS_RESPONSE,
  payload,
});
